import * as _ from 'lodash';

export interface IStringService {
  capitalize(str: any): string;

  normalize(str: any): string;
}

export class StringService implements IStringService {
  capitalize(str: string) {
    if (_.isNumber(str)) {
      return str;
    }

    return _.capitalize(str);
  }

  normalize(str: any) {
    return str
        ? _.chain(String(str))
            .trim()
            .deburr()
            .toLower()
            .value()
        : '';
  }
}

export const stringService = new StringService();
export const capitalize = stringService.capitalize;
export const normalize = stringService.normalize;
